export default () => {
	const sections = document.querySelectorAll('.hero');
	
	sections.forEach(function(section) {
		const btn = section.querySelector('.js-close-button');
		const wrapper = section.querySelector('.btn-overlay')
		
		if (btn && wrapper) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				wrapper.classList.add('is-fade-out');
			});
		}
	});
}